import { connect } from 'react-redux';
import WalletComponent from '../components/router/WalletComponent';

const mapStateToProps = (state) => ({
  user: state.user,
});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(WalletComponent);
